import desktopAgentIcon from '@easytools-assets/desktop-agent/desktop-agent.svg';

/**
 * Mappa dell'app admin: la usano la sidebar, il breadcrumb dell'header e la
 * palette comandi (Ctrl+K). Una voce aggiunta qui compare in tutti e tre.
 */
export interface AdminNavItem {
    to: string;
    label: string;
    /** Cosa si fa nella pagina: sottotitolo nella palette comandi. */
    description: string;
    icon: string;
    productIcon?: string;
    /** Parole extra per la ricerca nella palette. */
    keywords?: string;
}

export interface AdminNavSection {
    label: string;
    items: AdminNavItem[];
}

export const ADMIN_NAV: AdminNavSection[] = [
    {
        label: 'Panoramica',
        items: [
            { to: '/dashboard', label: 'Dashboard', description: 'Stato della piattaforma e cose da fare', icon: 'bi-grid-1x2', keywords: 'home overview kpi' },
        ],
    },
    {
        label: 'Catalogo e accessi',
        items: [
            { to: '/tools', label: 'Tools', description: 'Anagrafica, visibilità, immagini e guide dei tool', icon: 'bi-boxes', keywords: 'catalogo moduli plugin' },
            { to: '/users', label: 'Utenti', description: 'Approvazioni, ruoli e tool assegnati', icon: 'bi-people', keywords: 'approvazione ruolo admin accessi' },
            { to: '/messages', label: 'Comunicazioni', description: 'Avvisi e novità nella bacheca del portale', icon: 'bi-megaphone', keywords: 'messaggi avvisi bacheca news annunci' },
        ],
    },
    {
        label: 'Qualità',
        items: [
            { to: '/quality', label: 'Quality Center', description: 'Problemi, segnalazioni, eventi e remediation IA', icon: 'bi-heart-pulse', keywords: 'errori bug issue segnalazioni diagnostica' },
            { to: '/audit', label: 'Audit log', description: 'Chi ha fatto cosa nell’area admin', icon: 'bi-shield-check', keywords: 'log sicurezza tracciamento' },
        ],
    },
    {
        label: 'Piattaforma',
        items: [
            { to: '/jobs', label: 'Code e job', description: 'Job in coda, in esecuzione e falliti', icon: 'bi-list-task', keywords: 'queue coda background' },
            { to: '/agents', label: 'Agent e MCP', description: 'Console MCP e strumenti per gli agent', icon: 'bi-cpu', keywords: 'mcp ai assistant' },
            { to: '/desktop-agent', label: 'Desktop Agent', description: 'Pacchetto, dispositivi associati e pairing', icon: '', productIcon: desktopAgentIcon, keywords: 'companion pairing dispositivi' },
        ],
    },
];

export const ADMIN_NAV_ITEMS: AdminNavItem[] = ADMIN_NAV.flatMap(section => section.items);

/** Voce di menu e sezione della pagina corrente (match sul prefisso). */
export const findNavContext = (pathname: string): { section?: AdminNavSection; item?: AdminNavItem } => {
    for (const section of ADMIN_NAV) {
        const item = section.items.find(i => pathname === i.to || pathname.startsWith(`${i.to}/`));
        if (item) return { section, item };
    }
    return {};
};
